module.exports = __webpack_public_path__ + "static/media/ic_launcher.037c2a1d.png";